<div id="drug-page-grid">
  <app-ark-container
    [future]="dataObservable"
    [loadingTemplate]="loading"
    [successTemplate]="success"
    [failureTemplate]="failure"
    [errorTemplate]="error"
    (onSuccess)="onDataResolved($event[0])"
  >
  </app-ark-container>

  <ng-template #loading>
    <div nz-row nzType="flex">
      <div nz-col nzSpan="24">
        <va-custom-skeleton [customSkeletonConfig]="customSkeletonConfig">
        </va-custom-skeleton>
      </div>
    </div>
  </ng-template>

  <ng-template #success>
    <div nz-row nzType="flex">
      <div nz-col nzSpan="24">
        <div class="drug-page-grid-container">
          <table mat-table [dataSource]="dataSource" class="drug-grid">
            <!-- Name Column -->
            <ng-container matColumnDef="name" sticky>
              <th mat-header-cell *matHeaderCellDef></th>
              <td
                mat-cell
                *matCellDef="let element"
                [title]="element.name"
                [ngClass]="{
                  'cell-bold': element.doBold === true
                }"
              >
                <ng-container *ngIf="element.indentation">
                  <span
                    [ngStyle]="{
                      'padding-left': element.indentation * 10 + 'px'
                    }"
                  ></span>
                </ng-container>
                <span *ngIf="element.shortname && element.shortname != ''">
                  <a
                    href="/mex/{{ ticker }}/NMV/{{ element.shortname }}"
                    target="_blank"
                  >
                    {{ element.name }}
                  </a>
                </span>
                <span *ngIf="!element.shortname">
                  {{ element.name }}
                </span>
                <span class="dsm-icon" *ngIf="element.isResearchIconShow">
                  <va-icon
                    (click)="getDSMDOcumentDetails(element.dapparameter)"
                    isFontAwesome="true"
                    class=""
                    [name]="book"
                  ></va-icon>
                </span>
              </td>
            </ng-container>

            <!-- Currnecy Magnitude Column -->
            <ng-container matColumnDef="currency_magnitude" sticky>
              <th mat-header-cell *matHeaderCellDef>Unit</th>
              <td mat-cell *matCellDef="let element">
                {{
                  element.line_type || dataSettings.view_by[0] === "values"
                    ? element.meta_data && element.meta_data.unit == "Amount"
                      ? element.meta_data.currency + element.meta_data.magnitude
                      : element.meta_data && element.meta_data.unit !== "%"
                        ? element.meta_data.unit + element.meta_data.magnitude
                        : ""
                    : ""
                }}
              </td>
            </ng-container>

            <ng-container *ngFor="let colKey of periodList">
              <ng-container [matColumnDef]="colKey + ''">
                <th mat-header-cell *matHeaderCellDef class="period">
                  {{ colKey
                  }}{{ forecastPeriodData[colKey] === true ? "E" : "" }}
                </th>

                <td
                  mat-cell
                  *matCellDef="let element"
                  class="cell-numeric-value-alignment"
                  (click)="loadFormulaBar(element, colKey)"
                  [ngClass]="{
                    'cell-selected':
                      selectedCell ===
                      element.dapparameter + '|' + colKey + '|' + element.id
                  }"
                >
                  <span
                    class="cell-value"
                    [ngClass]="{
                      'cell-negative':
                        element.period_data_formatted &&
                        element.period_data_formatted[colKey] &&
                        element.period_data_formatted[colKey].includes('(')
                    }"
                  >
                    {{
                      element.period_data_formatted &&
                      element.period_data_formatted[colKey]
                        ? element.period_data_formatted[colKey]
                        : ""
                    }}
                  </span>
                </td>
              </ng-container>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayColumns; sticky: true"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayColumns"
              [ngClass]="{
                'row-selected': row.id === selectedRow
              }"
            ></tr>
          </table>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #failure>
    <div nz-row nzType="flex">Failure</div>
  </ng-template>

  <ng-template #error>
    <div nz-row nzType="flex">Error</div>
  </ng-template>
</div>
